export default __webpack_public_path__ + "static/home-14ea95958aa6cb97b26cf7645e559956.svg";